import api from './api';

export interface PageLink {
  text: string;
  url: string;
}

export interface PageSection {
  header: string;
  links: PageLink[];
}

export interface PageContent {
  id: string;
  slug: string;
  title: string;  // Keep for backward compatibility, but always "Information"
  bannerImageUrl?: string;
  sections?: PageSection[];
  createdAt: string;
  updatedAt: string;
}

const pageContentService = {
  async getPageBySlug(slug: string): Promise<PageContent> {
    const response = await api.get<PageContent>(`/page-content/${slug}`);
    return response.data;
  },

  async getAllPages(params?: { page?: number; limit?: number }): Promise<{
    data: PageContent[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  }> {
    const response = await api.get<{
      data: PageContent[];
      pagination: {
        total: number;
        page: number;
        limit: number;
        totalPages: number;
      };
    }>('/page-content', { params });
    return response.data;
  }
};

export default pageContentService;